var map = {
	"./A.svg": "15d7",
	"./B2C.svg": "31ce",
	"./Carbusiness.svg": "9f82",
	"./Carteam.svg": "6c39",
	"./Equipment.svg": "bc91",
	"./Frame.svg": "7fb7",
	"./OilCard.svg": "09c8",
	"./Profile.svg": "bdd6",
	"./Scheduling.svg": "0354",
	"./Unlock.svg": "5f4e",
	"./XMXX.svg": "a226",
	"./YPLS.svg": "9d6d",
	"./YPPF.svg": "0cc5",
	"./base.svg": "3f0e",
	"./feedback.svg": "cbf9",
	"./goods.svg": "7421",
	"./icon_exit.svg": "0f69",
	"./icon_home.svg": "d820",
	"./icon_voice.svg": "880c",
	"./insurance.svg": "36ab",
	"./pay.svg": "4415",
	"./signOut.svg": "0f58",
	"./yunying.svg": "1b26"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";